export var TABLE_FIELDS = function (TABLE_FIELDS) {
  TABLE_FIELDS["DATE"] = "date";
  TABLE_FIELDS["TIME"] = "time";
  TABLE_FIELDS["ACTION_TYPE"] = "actionType";
  TABLE_FIELDS["ACTION_DESCRIPTION"] = "actionDescription";
  TABLE_FIELDS["USER"] = "user";
  TABLE_FIELDS["CHANNEL"] = "channel";
  return TABLE_FIELDS;
}({});